<div [ngClass]="dynamicClass" class="eq-mt-[132px] lg:eq-mt-15">
  <div class="swiper eq-swiper-slider">
    <div class="swiper-wrapper">
      <ng-container *ngFor="let slide of rendering.fields?.HeroSliderItems">
        <div class="swiper-slide">          
          <div class="eq-flex eq-flex-col-reverse lg:eq-flex-row">
            <div class="lg:eq-w-1/2 eq-flex eq-items-center eq-h-[350px] lg:eq-h-auto">
              <div class="eq-container-slider-left eq-flex eq-flex-col eq-gap-[20px] lg:eq-gap-7" [ngClass]="{'eq-container': isMobile}">
                <div class="eq-flex eq-flex-col eq-gap-4 lg:eq-gap-[20px] eq-text-center lg:eq-text-left">
                  <ng-container *ngIf="slide.fields?.IsH1Tag.value">
                    <h1 class="eq-w-full lg:eq-w-4/5 eq-text-heading1-m lg:eq-text-heading1 eq-text-blue-darkBlue eq-font-bold" *scText="slide.fields?.Title"></h1>
                  </ng-container>
                  <ng-container *ngIf="!slide.fields?.IsH1Tag.value">
                    <h2 class="eq-w-full lg:eq-w-4/5 eq-text-heading1-m lg:eq-text-heading1 eq-text-blue-darkBlue eq-font-bold" *scText="slide.fields?.Title"></h2>
                  </ng-container>
                  <div class="eq-w-full lg:eq-w-4/5 eq-text-body-subtitle-m lg:eq-text-body-subtitle eq-text-black-natural-60" *scText="slide.fields?.Subtitle"></div>
                </div>
                <a *ngIf="slide.fields?.Link?.value?.href" class="eq-btn eq-btn-primary eq-w-full lg:eq-w-fit" hybridHref href="{{slide?.fields?.Link?.value?.href}}" attr.aria-label="{{slide?.fields?.Link?.value?.text}}">{{slide?.fields?.Link?.value?.text}}</a>
              </div>
            </div>
            <div class="lg:eq-w-1/2 eq-h-[265px] lg:eq-h-[740px] eq-mb-5 lg:eq-mb-0">
              <img *ngIf="!isMobile" class="eq-h-full eq-w-full eq-object-cover eq-object-left" [src]="slide.fields?.Image.value.src" [alt]="slide.fields?.Image.value.alt">
              <img *ngIf="isMobile" class="eq-h-full eq-w-full eq-object-cover eq-object-left" [src]="slide.fields?.MobileImage.value.src" [alt]="slide.fields?.MobileImage.value.alt">
            </div>
          </div>          
        </div>
      </ng-container>
    </div>
    <div class="swiper-pagination eq-swiper-pagination-left eq-h-8"></div>
  </div>   
</div>
